import React, {useState} from 'react';
import {Spinner} from 'reactstrap';

export const ModalDesactivarServicio = (props) => {
	/* Destructuring the props object. */
	const {setEstadoModal} = props;

	/* Creating a state variable called `EstadoModalInterno` and a function called
    `setEstadoModalInterno` that can be used to change the value of `EstadoModalInterno`. */
	const [EstadoModalInterno, setEstadoModalInterno] = useState(0);

	/**
	 * It sets the state of the modal to 0.
	 */
	const volver = () => {
		setEstadoModal(0);
	};
	/**
	 * It sets the state of the modal to 1, then it tries to fetch a URL, and then it sets the state of
	 * the modal to 3.
	 */
	async function cancelarServicio() {
		setEstadoModalInterno(1);
		try {
			let ss = await fetch('https://www.youtube.com/');
		} catch (e) {
			console.error('error envio datos [enviarPresupuesto]');
		}
		setEstadoModalInterno(3);
	}

	return (
		<div className='modalBaseFondoGD'>
			{EstadoModalInterno === 0 ? (
				<div className='modalBaseGD'>
					<div>
						¿Seguro que desea cancelar el servicio? Dejara de poder generar informes
						sobre su agencia
					</div>
					<div className='botonesGenerarInforme'>
						<div
							className='button'
							onClick={() => volver()}
						>
							<b>Seguir con el servicio</b>
						</div>
						<div
							className='button borrarCuenta'
							onClick={() => cancelarServicio()}
						>
							<b>Cancelar Servicio</b>
						</div>
					</div>
				</div>
			) : EstadoModalInterno === 1 ? (
				<div className='modalBaseGD'>
					<div>
						<Spinner />
					</div>
				</div>
			) : EstadoModalInterno === 2 ? (
				<div className='modalBaseGD'>
					<div>Servicio cancelado con exito</div>
					<div className='centrador'>
						<div
							className='button'
							onClick={() => volver()}
						>
							<b>Volver</b>
						</div>
					</div>
				</div>
			) : (
				<div className='modalBaseGD'>
					<div>El servicio no pudo ser cancelado</div>
					<div className='botonesGenerarInforme'>
						<div
							className='button'
							onClick={() => cancelarServicio()}
						>
							<b>Volver a intentar</b>
						</div>
						<div
							className='button borrarCuenta'
							onClick={() => volver()}
						>
							<b>Salir</b>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};
